<i18n>
{
	"en": {
		"title" : "Edit inbound EDI Setup",
		"notifyEdipartSaved" : "EDI setup saved!",
		"test": "Test setup (Files in endpoint will be read)",
		"notifyManualImportError": "Error occured when manually importing files. Check server logs",
		"notifyImportSuccess": "No error occured on import!",
		"notifyNoFilesImported": "No files imported"
	},
	"no":{
		"title" : "Rediger inngående EDI oppsett",
		"notifyEdipartSaved" : "EDI setup lagret!",
		"test": "Test setup (Filer i endepunkt blir lest inn)",
		"notifyManualImportError": "Feil oppstod ved manuell import av filer. Sjekk server logg",
		"notifyImportSuccess": "Importert uten feil!",
		"notifyNoFilesImported": "Ingen filer importert"
	}
}
</i18n>

<template>
	<t-dialog
		:title="$t('title')"
		:isShown="isDialogShown"
		:icon="'settings'"
		iconType="bp"
		@close="close"
		@ok="save"
		@cancel="close"
	>
		<InboundSettings style="height:500px;" :inboundEdiSetting="inboundEdiSetting"/>

		<template
			v-if="inboundEdiSetting.testMode"
			v-slot:additional-buttons
		>
			<t-button
				:value="$t('test')"
				appearance="minimal"
				type="bp"
				iconBefore="edi"
				@click="executeManualImport()"
			/>
		</template>

	</t-dialog>
</template>

<script>

import { mapActions } from '../store/details/ediSetupDetails.store';
import InboundSettings from './InboundSettings.vue';
import executeManualImport from './requests/executeManualImportRequest';

export default {
	components: { InboundSettings },
	props: {
		isDialogShown: Boolean,
		inboundEdiSetting: Object
	},
	data() {
		return { metaData: null, };
	},
	methods:{
		...mapActions(['executeSaveInboundSettings']),
		close() {
			this.$emit('close');
		},

		async executeManualImport() {
			let result = await executeManualImport(this.inboundEdiSetting);
			if (!result.status) {
				this.$notify({
					type: 'error',
					title: this.$t('notifyManualImportError')
				});
			}

			if (result.status && result.results.length === 0) {
				this.$notify({
					type: 'success',
					title: this.$t('notifyNoFilesImported')
				});
			}

			if (result.status && result.results.length !== 0) {
				this.$notify({
					type: 'success',
					title: this.$t('notifyImportSuccess')
				});
			}
		},
		save() {
			this.executeSaveInboundSettings(this.inboundEdiSetting);
			this.$notify({
				type: 'success',
				title: this.$t('notifyEdipartSaved')
			});
		},
	}
};
</script>

<style lang="scss" scoped>
.details-grid{
	display: grid;
	row-gap: 20px;
}
</style>